import script from "./MintComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MintComponent.vue?vue&type=script&lang=ts&setup=true"

import "./MintComponent.vue?vue&type=style&index=0&id=73a1b814&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a1b814"]])

export default __exports__